import { render, staticRenderFns } from "./BuyPointHistory.vue?vue&type=template&id=a2824874&scoped=true&"
import script from "./BuyPointHistory.vue?vue&type=script&lang=js&"
export * from "./BuyPointHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuyPointHistory.vue?vue&type=style&index=0&id=a2824874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2824874",
  null
  
)

export default component.exports